import { render, staticRenderFns } from "./ViewAcademicRecord.vue?vue&type=template&id=42c6d1c3&scoped=true"
import script from "./ViewAcademicRecord.vue?vue&type=script&lang=js"
export * from "./ViewAcademicRecord.vue?vue&type=script&lang=js"
import style0 from "./ViewAcademicRecord.vue?vue&type=style&index=0&id=42c6d1c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c6d1c3",
  null
  
)

export default component.exports